/* eslint-disable import/no-dynamic-require */

/**
 * This will setup the i18n language files and locale data for your app.
 */
import { addLocaleData } from 'react-intl';

const locale = require(`react-intl/locale-data/${process.env.APP_LOCALE || 'es' }`);
const translations = require(`../i18n/locales/${process.env.APP_LOCALE || 'es'}`);

addLocaleData(locale);

export { translations };
